import { SvgIcon, SxProps } from "@mui/material";
import ReactionLikeSvg from "jsx:../../../Images/Icons/Custom/reactionLike.svg";

export function ReactionLikeIcon(props: SxProps) {
    return <SvgIcon component={ReactionLikeSvg} inheritViewBox sx={props} />;
}
